<template>
	<div id="about">
		<div class="container-fluid"> 
			<div class="about-content">
				<div class="row">
					<div class="col-lg-6 col-md-12">
						<div class="about-left">
							<img
								class="img-fluid"
								:src="
									require('../assets/images/about/about-menu.jpg')
								"
								alt="stack house"
							/>
						</div>
					</div>
					<div class="col-lg-6 col-md-12">
						<div class="about-right">
							<h1 class="small-title mb-4">
								ONLY FOR FOODIES. LIFE IS TOO SHORT FOR AVERAGE
								FOOD!. LISTEN TO YOUR PALATE.
							</h1>
							<p class="samll-p">
								We are an Australian-inspired steakhouse
								restaurant beloved worldwide. We pride ourselves
								on serving up variety; our unbeatable steak cuts
								are complemented by delicious choices of
								chicken, ribs, seafood, and pasta at a price for
								everyone. Our strategy? We're the leader of the
								pack by emphasizing consistently high quality
								delicious food delivering a warm, welcoming
								environment. Our generous portions are
								moderately priced
							</p>
							<p class="samll-p hide-mobile">
								Lorem, ipsum dolor sit amet consectetur
								adipisicing elit. Repellendus accusamus deserunt
								eaque optio maiores modi reprehenderit nam
								vitae?
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "About",
	};
</script>
